import React, { useEffect, useRef } from "react";
import { FileText, Image as ImageIcon, MapPin, Music2, Sticker, UserRound, Video, } from "lucide-react";

function AttachmentMenu({ open, onSelectAttachment, onClose }) {

    const pickerRef = useRef(null);
    useEffect(() => {
        if (!open) return;

        const handleOutsideClick = (event) => {
            if (pickerRef.current && !pickerRef.current.contains(event.target)) {
                onClose?.();
            }
        };

        document.addEventListener("mousedown", handleOutsideClick);

        return () => {
            document.removeEventListener(
                "mousedown",
                handleOutsideClick,
            );
        };
    }, [open, onClose]);
    if (!open) return null;

    const attachments = [
        {
            type: "image",
            label: "Photos",
            icon: ImageIcon,
            iconClass:"bg-[#e8f8f1] text-[#00a884]",
        },
        {
            type: "video",
            label: "Video",
            icon: Video,
            iconClass:"bg-[#eef4ff] text-[#4b78d1]",
        },
        {
            type: "audio",
            label: "Audio",
            icon: Music2,
            iconClass:"bg-[#fff4e8] text-[#e58a25]",
        },
        {
            type: "document",
            label: "Document",
            icon: FileText,
            iconClass:"bg-[#f0f2f5] text-[#54656f]",
        },
    ];

    const disabledAttachments = [
        {
            label: "Location",
            icon: MapPin,
        },
        {
            label: "Contact",
            icon: UserRound,
        },
        {
            label: "Sticker",
            icon: Sticker,
        },
    ];

   return (
  <div className=" absolute bottom-[68px] left-[52px] z-50 w-[170px] overflow-hidden rounded-xl border border-border-color bg-card-bg p-1 shadow-[0_8px_28px_rgba(15,23,42,0.12)] transition-colors duration-200 dark:border-dark-border dark:bg-dark-card dark:shadow-[0_8px_28px_rgba(0,0,0,0.35)]">
    {attachments.map((item) => {
      const Icon = item.icon;

      return (
        <button
          key={item.type}
          type="button"
          onClick={() => onSelectAttachment(item.type)}
          className=" flex w-full items-center gap-2.5 rounded-lg px-2.5 py-1.5 text-left text-[11px] font-medium text-text-primary transition-all duration-200 hover:bg-theme-50 hover:text-primary dark:text-dark-text-primary dark:hover:bg-dark-soft-blue dark:hover:text-dark-primary">
          <span className={` flex h-7 w-7 shrink-0 items-center justify-center rounded-full ${item.iconClass}`}>
            <Icon size={14} strokeWidth={1.8} />
          </span>
          <span>{item.label}</span>
        </button>
      );
    })}

    <div className="my-1 border-t border-border-light dark:border-dark-border" />

    {disabledAttachments.map((item) => {
      const Icon = item.icon;
      return (
        <button
          key={item.label}
          type="button"
          disabled
          className=" flex w-full cursor-not-allowed items-center gap-2.5 rounded-lg px-2.5 py-1.5 text-left text-[11px] font-medium text-text-muted dark:text-dark-text-muted"
        >
          <span className=" flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-surface-bg text-text-muted dark:bg-dark-surface-bg dark:text-dark-text-muted">
            <Icon size={14} strokeWidth={1.8} />
          </span>
          <span>{item.label}</span>
        </button>
      );
    })}
  </div>
);
}

export default AttachmentMenu;